export const normalizeString = (str: string) =>
  str
    .toLocaleLowerCase()
    .normalize("NFD") // decompose accented letters
    .replace(/[\u0300-\u036f]/g, "");
